// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"391c99ee","513":"526df9cf","703":"3549b48c","787":"ba6f2846"}[chunkId] + ".chunk.js";
};